import { MasterTranslation } from '@/constants';
import { useGlobalState } from '@/hooks';
import {
  ActionTitle,
  CollapseAction,
  CollapseActionContainer,
  CollapseArrow,
  Collapsible,
} from './CollapsibleContent.styles';

interface ICollasibleContentProps {
  isOpen?: boolean;
  handleToggle?: () => void;
  children: React.ReactNode;
}

const CollapsibleContent = ({ isOpen = true, handleToggle, children }: ICollasibleContentProps) => {
  const { t } = useGlobalState();
  const actionTitle = isOpen ? t(MasterTranslation.ViewLess) : t(MasterTranslation.ViewMore);

  return (
    <>
      {/* Collapsible Content */}
      <Collapsible isOpen={isOpen}>{children}</Collapsible>
      {/* Action */}
      <CollapseActionContainer>
        <CollapseAction onClick={handleToggle}>
          <ActionTitle>{actionTitle}</ActionTitle>
          <CollapseArrow isOpen={isOpen} />
        </CollapseAction>
      </CollapseActionContainer>
    </>
  );
};

export { CollapsibleContent };
